(() => {
  async function mount(root) {
    if (root.dataset.moxMounted) return;
    root.dataset.moxMounted = 'true';
    const grid = root.querySelector('[data-directory-grid]');
    const nav = root.querySelector('[data-directory-pagination]');
    if (!grid || !nav) return;
    const byUrl = new Map();
    const collect = container => container.querySelectorAll('.mox-directory__card').forEach(card => byUrl.set(card.getAttribute('href'), card));
    collect(root);
    // Reuse the first server page already in the DOM; other entry pages still start at page one.
    const first = new URL(location.href);
    first.searchParams.delete('page');
    first.searchParams.delete('collection_page');
    const visited = new Set();
    let next = first;
    try {
      if (Number.parseInt(nav.dataset.currentPage, 10) === 1) {
        visited.add(first.href);
        const link = nav.querySelector('a[rel="next"]');
        next = link ? new URL(link.getAttribute('href'), location.href) : null;
      }
      while (next) {
        if (next.origin !== location.origin || visited.has(next.href)) throw new Error('Invalid collection pagination');
        visited.add(next.href);
        const response = await fetch(next.href, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Collection page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = doc.querySelector('[data-mox-directory]');
        if (!page) throw new Error('Collection directory missing');
        collect(page);
        const link = page.querySelector('[data-directory-pagination] a[rel="next"]');
        next = link ? new URL(link.getAttribute('href'), next) : null;
      }
    } catch (error) {
      // Keep the original Shopify links and cards usable if a page cannot be loaded.
      delete root.dataset.moxMounted;
      return;
    }
    const locale = document.documentElement.lang || 'fr';
    const cards = [...byUrl.values()].sort((a,b) => a.title.localeCompare(b.title, locale, {sensitivity:'base',numeric:true}));
    grid.replaceChildren(...cards);
    let current = Math.max(1, Number.parseInt(new URL(location.href).searchParams.get('collection_page'),10) || 1);
    const columns = () => getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
    let perPage = columns() * 6;
    const status = document.createElement('span');
    status.setAttribute('role','status');
    const prevLabel = nav.dataset.previousLabel;
    const nextLabel = nav.dataset.nextLabel;
    function render(updateUrl = false) {
      const pages = Math.max(1,Math.ceil(cards.length / perPage));
      current = Math.min(pages,Math.max(1,current));
      const start = (current - 1) * perPage;
      cards.forEach((card,index) => { card.hidden = index < start || index >= start + perPage; });
      nav.replaceChildren();
      function button(text, target, disabled = false) {
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = text; button.disabled = disabled;
        if (target === current && /^\d+$/.test(text)) button.setAttribute('aria-current','page');
        button.addEventListener('click', () => {
          current = target; render(true);
          root.scrollIntoView({block:'start',behavior:'auto'});
          nav.querySelector('[aria-current="page"]')?.focus({preventScroll:true});
        });
        nav.append(button);
      }
      button(prevLabel,current-1,current===1);
      const visible = new Set([1,pages,current-2,current-1,current,current+1,current+2]);
      let last = 0;
      [...visible].filter(p=>p>=1&&p<=pages).sort((a,b)=>a-b).forEach(p=>{
        if(last && p>last+1){const dots=document.createElement('span');dots.textContent='…';nav.append(dots);}
        button(String(p),p);last=p;
      });
      button(nextLabel,current+1,current===pages);
      status.textContent = `${current} / ${pages}`;
      nav.append(status);
      if(updateUrl){const url=new URL(location.href);url.searchParams.delete('page');url.searchParams.set('collection_page',String(current));history.replaceState(null,'',url);}
    }
    render();
    let width = grid.clientWidth;
    new ResizeObserver(() => {
      if (grid.clientWidth === width) return;
      width = grid.clientWidth;
      const nextSize = columns() * 6;
      if(nextSize !== perPage){const anchor=(current-1)*perPage;perPage=nextSize;current=Math.floor(anchor/perPage)+1;render(true);}
    }).observe(grid);
  }
  const start = () => document.querySelectorAll('[data-mox-directory]').forEach(mount);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
